<div class="container">
  <div class="single_element">
    <div class="quick_activity">
      <h5>المنصة <span>العلاجية</span></h5>

      <div class="quick_activity_wrap">
        <div class="row g-24">
          <div class="col-lg-4">
            <div class="card-light-border admin-card admin-card-1">
              <div class="icon">
                <img src="assets/images/icons/stethoscope-icon.svg" alt="" />
              </div>
              <h3>قائمة المرضى</h3>
              <a routerLink="/Sas/ViewSpecialistPatient">
                <img
                  src="assets/images/icons/arrow-left.svg"
                  alt="arrow icon"
                />
              </a>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card-light-border admin-card admin-card-2">
              <div class="icon">
                <img
                  src="assets/images/icons/medicine-icon-orange.svg"
                  alt=""
                />
              </div>
              <h3>الحجوزات القادمة</h3>
              <a routerLink="/Sas/UpcommingBookings">
                <img
                  src="assets/images/icons/arrow-left.svg"
                  alt="arrow icon"
                />
              </a>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card-light-border admin-card admin-card-3">
              <div class="icon">
                <img src="assets/images/icons/list-icon-info.svg" alt="" />
              </div>
              <h3>حالة حجوزات الجلسات بالتاريخ</h3>
              <a routerLink="/Sas/My-Schedule">
                <img
                  src="assets/images/icons/arrow-left.svg"
                  alt="arrow icon"
                />
              </a>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card-light-border admin-card admin-card-5">
              <div class="icon">
                <img
                  src="assets/images/icons/calendar-icon-yellow.svg"
                  alt=""
                />
              </div>
              <h3>تحديد توقيت المواعيد المتاحة</h3>
              <a routerLink="/Sas/Schedule">
                <img
                  src="assets/images/icons/arrow-left.svg"
                  alt="arrow icon"
                />
              </a>
            </div>
          </div>
          <div class="col-lg-4" *ngIf="specialist.joinedInYourConsultant">
            <div class="card-light-border admin-card admin-card-4">
              <div class="icon">
                <img src="assets/images/icons/calling-icon.svg" alt="" />
              </div>
              <h3>تحديد توقيت المواعيد المتاحة لمستشارك في التخاطب</h3>
              <a routerLink="/Sas/ConsultantScheduleGenerate">
                <img
                  src="assets/images/icons/arrow-left.svg"
                  alt="arrow icon"
                />
              </a>
            </div>
          </div>

          <div class="col-lg-4">
            <div class="card-light-border admin-card admin-card-6">
              <div class="icon">
                <img
                  src="assets/images/icons/medical-report-lavender.svg"
                  alt=""
                />
              </div>
              <h3>التقارير الطبية</h3>
              <a routerLink="/Sas/SpecialistReports">
                <img
                  src="assets/images/icons/arrow-left.svg"
                  alt="arrow icon"
                />
              </a>
            </div>
          </div>

          <!-- <div class="col-lg-4">
            <a routerLink="/Sas/ViewSpecialistPatient">
              <div class="single_quick_activity">
                <img src="assets/images/2.png" class="img-fluid" width="50" />
                <h3>قائمة المرضى</h3>
              </div>
            </a>
          </div>

          <div class="col-lg-4">
            <a routerLink="/Sas/UpcommingBookings">
              <div class="single_quick_activity single_quick_activity5">
                <img src="assets/images/5.png" class="img-fluid" width="50" />
                <h3>الحجوزات القادمة</h3>
              </div>
            </a>
          </div>

          <div class="col-lg-4">
            <a routerLink="/Sas/My-Schedule">
              <div class="single_quick_activity single_quick_activity3">
                <img src="assets/images/7.png" class="img-fluid" width="50" />
                <h3>حالة حجوزات الجلسات بالتاريخ</h3>
              </div>
            </a>
          </div> -->
        </div>

        <!-- <div class="row">
          <div class="col-lg-4">
            <a routerLink="/Sas/Schedule">
              <div class="single_quick_activity single_quick_activity4">
                <img
                  src="assets/images/cal2.png"
                  class="img-fluid"
                  width="50"
                />
                <h3>تحديد توقيت المواعيد المتاحة</h3>
              </div>
            </a>
          </div>

          <div class="col-lg-4" *ngIf="specialist.joinedInYourConsultant">
            <a routerLink="/Sas/ConsultantScheduleGenerate">
              <div class="single_quick_activity single_quick_activity2">
                <img
                  src="assets/images/contacts.png"
                  class="img-fluid"
                  width="50"
                />
                <h3>تحديد توقيت المواعيد المتاحة لمستشارك في التخاطب</h3>
              </div>
            </a>
          </div>

          <div class="col-lg-4">
            <a routerLink="/Sas/SpecialistReports">
              <div class="single_quick_activity single_quick_activity6">
                <img
                  src="assets/images/medical-file.png"
                  class="img-fluid"
                  width="50"
                />
                <h3>التقارير الطبية</h3>
              </div>
            </a>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</div>
